export default __webpack_public_path__ + "static/technical-development-7f95d8ecd2bf765b3ac38430b6d00f6e.webp";